/**
 * Góp ý cấp dưới
 * NXCHIEN 21.03.2024
 */
export default {
  AutoGenerateAmount: 1,  // tự động sinh góp ý số tiền
  AutoGenerateContent: 2,  // tự động sinh góp ý thay đổi nội dung
  UserGenerate: 3,  // người dùng nhập góp ý
};